import PropTypes from 'prop-types';

export const NavigationItemPropTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
};
